import { parseAdminHash, serializeAdminHash } from '@app/pages/admin/admin-hash-state';

export const OPERATION_DETAILS_TABS = ['overview', 'events', 'notifications', 'request-steps', 'storage', 'logs'] as const;

export type OperationDetailsTab = (typeof OPERATION_DETAILS_TABS)[number];

const LEGACY_OPERATION_DETAILS_TABS: Record<string, OperationDetailsTab> = {
  database: 'storage',
};

export function canonicalizeOperationDetailsTab(tab: string | null | undefined): OperationDetailsTab | null {
  if (!tab) {
    return null;
  }
  const mapped = LEGACY_OPERATION_DETAILS_TABS[tab] ?? tab;
  return isOperationDetailsTab(mapped) ? mapped : null;
}

export function operationDetailsUrl(
  kind: string | null | undefined,
  id: string,
  tab?: string | null,
): string {
  const path = kind === 'JobExecution'
    ? `/admin/orchestration/jobs/${id}`
    : `/admin/orchestration/assignments/${id}`;
  const hash = operationDetailsTabHash(tab);
  return hash ? `${path}#${hash}` : path;
}

export function operationDetailsUrlFromHash(fragment: string | null | undefined): string | null {
  const state = parseAdminHash(fragment);
  const kind = state['kind'];
  const id = state['id'];
  if (!id || (kind !== 'Assignment' && kind !== 'JobExecution')) {
    return null;
  }
  return operationDetailsUrl(kind, id, state['tab']);
}

export function isOperationDetailsTab(tab: string | null | undefined): tab is OperationDetailsTab {
  return OPERATION_DETAILS_TABS.includes(tab as OperationDetailsTab);
}

export function operationDetailsTabFromHash(fragment: string | null | undefined): OperationDetailsTab {
  return canonicalizeOperationDetailsTab(parseAdminHash(fragment)['tab']) ?? 'overview';
}

export function operationDetailsTabHash(tab: string | null | undefined): string | null {
  const canonical = canonicalizeOperationDetailsTab(tab);
  if (!canonical || canonical === 'overview') {
    return null;
  }
  return serializeAdminHash({ tab: canonical }) ?? null;
}
